// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XnlR","textarea":"styles_textarea__3s2ZJ"};